// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1b6he","label":"Category_label__XzN_5","content":"Category_content__2esjY","header":"Category_header__Z2n7t","location":"Category_location__z-PZ_"};